import { API_REQUEST, apiError, apiSuccess } from '../../actions/api.actions';
import { isNil } from 'ramda';
import axios from 'axios';
import uuid from 'react-uuid';
import { Parse } from 'parse';

export const apiMiddleWare =
  ({ dispatch }) =>
  (next) =>
  async (action) => {
    next(action);
    if (!action.type.includes(API_REQUEST)) return;

    const { feature, params, func, method, api, endPoint } = action.meta;

    if (feature === '[SESSIONS]') {
      if (func === 'deleteSession') {
        const response = await Parse.User.logOut();
        dispatch(apiSuccess({ response, feature, func }));
        return;
      }
      try {
        const response = await Parse.User.logIn(params.email, params.password);
        dispatch(apiSuccess({ response, feature }));
      } catch (error) {
        dispatch(apiError({ error, feature }));
      }
      return;
    }

    if (api === 'kinects') {
      const stage =
        process.env.REACT_APP_STAGE === 'LOCAL'
          ? 'LOCAL'
          : ['DEV', 'DEVELOP'].includes(process.env.REACT_APP_STAGE)
          ? 'DEVELOP'
          : 'PRODUCTION';
      const kinectsUrl = new URL(
        `${
          process.env.REACT_APP_BACKEND_PROVIDER === 'firebase'
            ? process.env[`REACT_APP_KINECTS_FIREBASE_${stage}_URL`] ||
              process.env.REACT_APP_KINECTS_FIREBASE_URL
            : process.env[`REACT_APP_KINECTS_${stage}_URL`]
        }/${endPoint}`
      );
      kinectsUrl.searchParams.set('redirectPath', window.location);
      if (params?.configuration)
        kinectsUrl.searchParams.set(
          'configuration',
          JSON.stringify(params.configuration)
        );
      if (params?.reconnect) kinectsUrl.searchParams.set('reconnect', 'true');
      if (!isNil(params?.scope) && params.scope !== '') {
        kinectsUrl.searchParams.set('scope', params.scope);
      }
      try {
        const response = await axios({
          method,
          url: kinectsUrl.toString(),
          data: action.payload,
          headers: {
            'X-Parse-Application-Id': process.env.REACT_APP_API_KEY,
            'X-Parse-Session-Token': Parse.User.current().getSessionToken(),
          },
        });
        if (response.data?.redirectUrl) {
          window.location = response.data.redirectUrl;
          return;
        }
        dispatch(apiSuccess({ results: response.data, feature, func }));
      } catch (error) {
        dispatch(apiError({ error, feature }));
      }
      return;
    }

    // Existing ACRCloud creation remains intact until resolveSignal ships.
    if (func === 'createMedia') {
      try {
        params.id = uuid();
        params.apiKey = process.env.REACT_APP_TAGGER_API_KEY;
        const file = params.audio_file[0];
        params.type = file.type;
        const lambdaUrl =
          process.env[`REACT_APP_${process.env.REACT_APP_STAGE}_LAMBDA_URL`];
        const upload = await axios({
          method: 'post',
          url: `${lambdaUrl}upload`,
          data: params,
          headers: {
            'Content-Type': 'application/json',
            'x-api-key': params.apiKey,
          },
        });
        await axios({
          method: 'put',
          url: upload.data.url,
          data: file,
          headers: { 'Content-Type': file.type },
        });
        const fingerprint = await axios({
          method: 'post',
          url: `${lambdaUrl}fingerPrint`,
          data: params,
          headers: {
            'Content-Type': 'application/json',
            'x-api-key': params.apiKey,
          },
        });
        const results = await Parse.Cloud.run('createMedia', {
          acrId: fingerprint.data.acr_id,
          name: params.title,
          description: params.description,
          apiKey: params.apiKey,
        });
        dispatch(apiSuccess({ results, feature, func }));
      } catch (error) {
        dispatch(apiError({ error, feature }));
      }
      return;
    }

    try {
      const cloudParams = { ...(params || {}) };
      cloudParams.apiKey = process.env.REACT_APP_TAGGER_API_KEY;
      delete cloudParams.parent;
      const results = await Parse.Cloud.run(func, cloudParams);
      if (results?.statusCode === 302) {
        window.location = results.headers.Location;
        return;
      }
      dispatch(apiSuccess({ results, feature, func }));
    } catch (error) {
      if (error.message === 'Invalid session token') {
        await Parse.User.logOut();
      } else {
        dispatch(apiError({ error, feature }));
      }
    }
  };
